import {
    FETCH_LOGIN_REQUEST,
    FETCH_SIGNUP_REQUEST,
    FETCH_TODO_FAILURE,
    FETCH_TODO_SUCCESS,
    SET_ACCOUNT_REQUEST,
    SET_ACCOUNT_VALUE
} from "./actionTypes";
import {
    FetchAccountFailurePayload,
    FetchAccountSuccessPayload,
    FetchLoginAccoutRequest,
    FetchSignupAccountRequest,
    FetchTodoAccountFailure,
    FetchTodoAccountSuccess,
    SetAccountPayload,
    SetAccountRequest,
    SetAccountSuccess,
} from "./types";

export const fetchLoginAccountRequest = (object: any, callback:any) : FetchLoginAccoutRequest =>({
    type: FETCH_LOGIN_REQUEST,
    body: object,
    callback
})
export const fetchSignupAccountRequest = (object: any) : FetchSignupAccountRequest =>({
    type: FETCH_SIGNUP_REQUEST,
    body: object
})
export const fetchAccountFailure = (
    payload: FetchAccountFailurePayload,
): FetchTodoAccountFailure =>({
    type: FETCH_TODO_FAILURE,
    payload
});
export const fetchAccountSuccess = (
    payload: FetchAccountSuccessPayload
): FetchTodoAccountSuccess =>({
    type: FETCH_TODO_SUCCESS,
    payload
});
export const setAccountRequest = () : SetAccountRequest =>({
    type: SET_ACCOUNT_REQUEST,
})
export const setAccountSuccess = (
    payload: SetAccountPayload
): SetAccountSuccess =>({
    type: SET_ACCOUNT_VALUE,
    payload
})